<div class="spinner-wrapper">
	<mat-spinner diameter="40"></mat-spinner>
</div>
